import { createFileRoute } from "@tanstack/react-router";
import { VesselDetailPage } from "~/pages/vessels/VesselDetailPage";
export const Route = createFileRoute("/_authenticated/vessels/$vesselSlug")({ component: VesselDetailPage });
